/** O peso em kg como o servidor aceita: `''` limpa, vírgula vale como ponto, de 0 até 100.000. */
export function parseWeightKg(raw: string): { value: number | null; error?: string } {
  if (raw.trim() === '') return { value: null };
  const value = Number(raw.replace(',', '.'));
  if (!Number.isFinite(value) || value < 0 || value >= 100000) {
    return { value: null, error: 'Informe o peso em kg, de 0 a menos de 100.000.' };
  }
  return { value };
}

export const dialogFieldSx = { '& .MuiFormHelperText-root': { fontSize: '1rem' } };
